import {
  CHECK_EMAIL_REQUEST,
  CHECK_EMAIL_SUCCESS,
  CHECK_EMAIL_FAIL,
  CHECK_EMAIL_RESET,
  CHECK_SECONDARY_EMAIL_REQUEST,
  CHECK_SECONDARY_EMAIL_SUCCESS,
  CHECK_SECONDARY_EMAIL_FAIL
} from '../../constants/check-email'

const initialState = {
  loading: false,
  loadingSecondary: false,
  error: '',
  errorSecondaryEmail: '',
  statusResult: null,
  checkEmail: null,
  isSecondaryEmailValid: false
}

const checkEmailReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_EMAIL_REQUEST:
      return { ...state, loading: true, checkEmail: null}
    case CHECK_EMAIL_SUCCESS:
      return { ...state, loading: false, checkEmail: 'success', statusResult : action.payload}
    case CHECK_EMAIL_FAIL:
      return { ...state, loading: false, error: action.payload, checkEmail: 'error' }
    case CHECK_EMAIL_RESET:
      return { ...state, loading: false, error: '', checkEmail: null, statusResult: null}
    case CHECK_SECONDARY_EMAIL_REQUEST:
      return { ...state, loadingSecondary: true, errorSecondaryEmail: null, isSecondaryEmailValid: false}
    case CHECK_SECONDARY_EMAIL_SUCCESS:
      return { ...state, loadingSecondary: false, errorSecondaryEmail: null, isSecondaryEmailValid: true}
    case CHECK_SECONDARY_EMAIL_FAIL:
      return { ...state, loadingSecondary: false, errorSecondaryEmail: action.payload, checkSecondaryEmail: 'error', isSecondaryEmailValid: false }
    default:
      return state
  }
}

export default checkEmailReducer